<!-- 投放数据周维度看板 -->
<template>
	<div id="fansRank">
		<div :style="{'width':table_scroll_width + 'px',}">
		<div :style="{'width':body_width + 'px',}" style="position: sticky;left: 30px;z-index: 5;">
			<!-- 标题 -->
			<div class="page-title">投放数据周维度看板</div>
			
			<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
				<div class="screen-box">
					<div class="screen-label">投放日期</div>
					<a-range-picker style="width:260px;" @change="onChangeDate" :allowClear="false"
					:locale="locale" 
					:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
				</div>
				
				<div class="screen-box">
					<div class="screen-label">投手</div>
					<a-select
						show-search
						style="min-width: 160px"
						placeholder="请选择投手"
						@change="handleChangeA"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
					  >
						<a-select-option v-for="(item,index) in filterList.op_id.list" :key="index" :value="item.key" >
						  {{item.value}}
						</a-select-option>
					</a-select>
					
				</div>
				
				<div class="screen-box">
					<div class="screen-label">投放书籍</div>
					<a-select
						show-search
						style="min-width: 220px"
						placeholder="请选择投放书籍"
						@change="handleChangeB"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
					  >
					  <!-- 这里的value用key是因为有重名的，有重名的内容就会报错，所以用key，key是唯一的 -->
						<a-select-option v-for="(item,index) in filterList.book_id.list" :key="index" :value="item.key">
						  {{item.value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="screen-box">
					<div class="screen-label">媒体渠道</div>
					<a-select
						show-search
						style="min-width: 160px"
						placeholder="请选择媒体渠道"
						@change="handleChangeE"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
					  >
						<a-select-option v-for="(item,index) in filterList.media_id.list" :key="index" :value="item.key">
						  {{item.value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="screen-box">
					<div class="screen-label">书城</div>
					<a-select
						show-search
						style="min-width: 180px"
						placeholder="请选择书城"
						@change="handleChangeF"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer"
						allowClear
					  >
						<a-select-option v-for="(item,index) in filterList.channel_id.list" :key="index" :value="item.key">
						  {{item.value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="screen-box">
					<div class="screen-label">公众号</div>
					<!-- @popupScroll="popupScrollG" -->
					<a-select
						show-search
						style="min-width: 240px"
						placeholder="请选择公众号"
						@change="handleChangeG"
						:filter-option="filterOption"
						:getPopupContainer="getsPopupContainer" 
						allowClear
					  >
						<a-select-option v-for="(item,index) in filterList.gzh_id.list" :key="index" :value="item.key">
						  {{item.value}}
						</a-select-option>
					</a-select>
				</div>
				
				<div class="screen-box">
					<a-button @click="searchButton" :loading="search_button_loading" type="primary" icon="search" style="margin-left: 20px;">搜索</a-button>
				</div>
			</div>
		</div>
		</div>	
		
		<div>
			<!-- 表头 -->
			<div class="table-th"  :style="{'width': table_scroll_width + 'px'}">
				<div  class="table-th-cell-sticky" style="display: flex;align-items: center;">
					<div class="table-th-cell"
					:style="{'width':rableTitle[0].width + 'px',}">
						{{rableTitle[0].title}}
					</div>
					<div class="table-th-cell"
					:style="{'width':rableTitle[1].width + 'px','justify-content': rableTitle[1].text_right?'flex-end':''}">
						{{rableTitle[1].title}}
					</div>
					<div class="table-th-cell"
					:style="{'width':rableTitle[2].width + 'px','justify-content': rableTitle[1].text_right?'flex-end':''}">
						{{rableTitle[2].title}}
					</div>
				</div>
				<div  v-for="(item,index) in rableTitle" :key="index" >
					<div class="table-th-cell"  v-if="index > 2" 
					:style="{'width':item.width + 'px','justify-content': item.text_right?'flex-end':''}">
						{{item.title}}
					</div>
				</div>
			</div>
			
			<!-- 表格内容 -->
			
				<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
					<div  class="table-td-cell-sticky" style="display: flex;align-items: center;" :style="{'height': item.height + 'px'}">
						<!-- 周数 -->
						<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
							{{item.start_date}} -- {{item.end_date}}
						</div>
						<!-- 总消耗 -->
						<div  class="table-td-cell" style="display:flex;text-align: right;" :style="{'width':rableTitle[1].width + 'px','justify-content': rableTitle[1].text_right?'flex-end':''}">
							{{item.total_used | tableToFixed}}
						</div>
						<!-- 总回款 -->
						<div  class="table-td-cell" style="display:flex;" :style="{'width':rableTitle[2].width + 'px','justify-content': rableTitle[1].text_right?'flex-end':''}">
							{{item.total_left | tableToFixed}}
						</div>
					</div>
					
					<!-- 第1周 -->
					<div  class="table-td-cell text-right" :style="{'width':rableTitle[3].width + 'px'}">
						{{item.week_1 | tableToFixed}}
					</div>
					<!-- 第2周 -->
					<div  class="table-td-cell text-right" :style="{'width':rableTitle[4].width + 'px'}">
						{{item.week_2 | tableToFixed}}
					</div>
					<!-- 第3周 -->
					<div  class="table-td-cell text-right" :style="{'width':rableTitle[5].width + 'px'}">
						{{item.week_3 | tableToFixed}}
					</div>
					<!-- 第4周 -->
					<div  class="table-td-cell text-right" :style="{'width':rableTitle[6].width + 'px'}">
						{{item.week_4 | tableToFixed}}
					</div>
					<!-- 第5周 -->
					<div  class="table-td-cell text-right" :style="{'width':rableTitle[7].width + 'px'}">
						{{item.week_5 | tableToFixed}}
					</div>
					<!-- 第6周 -->
					<div  class="table-td-cell text-right" :style="{'width':rableTitle[8].width + 'px'}">
						{{item.week_6 | tableToFixed}}
					</div>
					<!-- 第7周 -->
					<div  class="table-td-cell text-right" :style="{'width':rableTitle[9].width + 'px'}">
						{{item.week_7 | tableToFixed}}
					</div>
					<!-- 第8周 -->
					<div  class="table-td-cell text-right" :style="{'width':rableTitle[10].width + 'px'}">
						{{item.week_8 | tableToFixed}}
					</div>
				</div>
			
			
			<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_null_width + 'px'}">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
		</div>
		
		<!-- 加载中 -->
		<div class="loading-box" v-show="search_button_loading">
			<a-spin size="large" />
		</div>
	</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { putDataMenu, panelWeekList, } from '@/request/api'

export default {
	name: 'fansRank',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2020-05-01', // 投放日期-开始时间
			endTime: '2022-06-30', // 投放日期-结束时间
			
			r_date_key:"",
			
			
			filterList: { // 搜索条件内容
				media_id:{},
				book_id:{},
				op_id:{},
				channel_id: {},
				gzh_id: {},
				book_type: {},
				show_type: {},
				has_money:{},
			}, 
			r_op_id: [], // 投手
			r_put_book: [], // 投放书籍
			r_media_id: [], // 媒体渠道
			r_channel_id: [], // 书城
			r_gzh_id: [], // 公众号
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"周数",width:160, type:"start_date",sort_:90, text_right: false,}, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"总消耗",width:150, type:"total_used",sort_:89, text_right: true,},
				{title:"总回款",width:150, type:"total_left",sort_:88, text_right: true,},
				{title:"第1周",width:120, type:"week_1",sort_:87, text_right: true,},
				{title:"第2周",width:120, type:"week_2",sort_:86, text_right: true,},
				{title:"第3周",width:120, type:"week_3",sort_:85, text_right: true,},
				{title:"第4周",width:120, type:"week_4",sort_:85, text_right: true,},
				{title:"第5周",width:120, type:"week_5",sort_:85, text_right: true,},
				{title:"第6周",width:120, type:"week_6",sort_:85, text_right: true,},
				{title:"第7周",width:120, type:"week_7",sort_:85, text_right: true,},
				{title:"第8周",width:120, type:"week_8",sort_:85, text_right: true,},
			],
			tableShowData: [],
			table_scroll_width: 1600,
			body_width: 1600,
			table_null_width: 1500, // 表格内容为空时，空提示的宽度范围
			search_button_loading: false, // 搜索按钮的加载状态
			r_limit: 30,
			r_page: 1,
		}
	},
	mounted(){
		let that = this
		
		
		// 获取7天前日期
		let date1 = new Date(new Date().getTime() - 604800000);
		let month1
		if(date1.getMonth() + 1 < 10){
			month1 = '0' + (date1.getMonth() + 1)
		}
		else {
			month1 = date1.getMonth() + 1
		}
		let day1
		if(date1.getDate() < 10){
			day1 = "0" + date1.getDate()
		}
		else {
			day1 = date1.getDate()
		}
		that.startTime = date1.getFullYear() + "-" + month1 + "-" + day1
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		
		
		// 获取表格信息
		let table_info = this.$getTableInfo(that.rableTitle)
		that.body_width = table_info.body_width
		that.table_scroll_width = table_info.table_width
		that.table_null_width = table_info.null_width
		
		this.search_button_loading = true
		putDataMenu().then((res)=>{
			console.log("putDataMenu",res.data.data.filter)
			that.filterList = res.data.data.filter
			
			this.search_button_loading = false
		})
		.catch(err=>{
			this.search_button_loading = false
		})
	},
	methods:{
		// 日期选择
		onChangeDate(date, dateString) {
			console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 投手
		handleChangeA(value) {
		    console.log(`selected ${value}`);
			// 这里接收的value参数就是一个数组
			this.r_op_id = value || ""
		},
		// 投放书籍
		handleChangeB(value) {
			this.r_put_book = value || ""
		    console.log(`selected ${value}`);
		},

		// 媒体渠道
		handleChangeE(value) {
			this.r_media_id = value || ""
		    console.log(`selected ${value}`);
		},

		// 书城
		handleChangeF(value) {
			this.r_channel_id = value || ""
		    console.log(`selected ${value}`);
		},

		// 公众号
		handleChangeG(value) {
			this.r_gzh_id = value || ""
		    console.log(`selected ${value}`);
		},

		
		// 搜索按钮
		searchButton(){
			let that = this
			
			that.search_button_loading = true
			let r_data = {
				channel_id: that.r_channel_id,
				gzh_id: that.r_gzh_id,
				put_book: that.r_put_book,
				date_start: that.startTime.replace(/-/g, ''),
				date_end: that.endTime.replace(/-/g, ''),
				op_id: that.r_op_id,
			}
			panelWeekList(r_data).then((res)=>{
				console.log("搜索",res)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.tableShowData = res.data.data.list || []
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		}
	},
	filters: {
		tableToFixed(value){
			// console.log("过滤器",value)
			// return value.toFixed(2)
			let ttt
			if(Number(value)){
				
				ttt = Number(value).toFixed(2) // 不转化成数字类型的数据的话，遇到字符串的值就会报错
			}
			else {
				ttt = 0
			}
			return ttt
		}
	}
}
</script>

<style scoped>
.text-right {
	text-align: right;
}
</style>